
import Vue from "vue";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import _ from "lodash";
import { AxiosResponse } from "axios";
import { download } from "@/functions/global.function";
import toast from "@/functions/toast.function";
import { Prop, Watch } from "vue-property-decorator";
import HeaderPartnership1 from "@/components/partnership/HeaderPartnership1.vue";
import HeaderPartnership2 from "@/components/partnership/HeaderPartnership2.vue";
import HeaderPartnership3 from "@/components/partnership/HeaderPartnership3.vue";
@Component({
  components: {
    HeaderPartnership3,
    HeaderPartnership2,
    HeaderPartnership1,
  },
})
export default class HeaderPartnership extends Vue {
  @Action("getIndustry", { namespace: "admin" })
  private getIndustry: any;
  @Action("getCountry", { namespace: "admin" })
  private getCountry: any;
  @Action("getProvince", { namespace: "admin" })
  private getProvince: any;
  @Action("getCity", { namespace: "admin" })
  private getCity: any;
  @Action("partnershipFind", { namespace: "school" })
  private partnershipFind: any;
  @Action("partnershipLatestAgreement", { namespace: "school" })
  private partnershipLatestAgreement: any;
  @Action("partnershipCheckLatestAgreement", { namespace: "school" })
  private partnershipCheckLatestAgreement: any;
  @Action("partnershipSendOtp", { namespace: "school" })
  private partnershipSendOtp: any;
  @Action("partnershipValidate", { namespace: "school" })
  private partnershipValidate: any;
  @Action("partnershipRegister", { namespace: "school" })
  private partnershipRegister: any;

  @State("school", { namespace: "school" })
  private school!: any;

  @Prop({ default: 1 })
  private templateNumber!: number;

  private industries: Array<any> = [];
  private countries: Array<any> = [];
  private provinces: Array<any> = [];
  private cities: Array<any> = [];

  private get canReSendOtp() {
    return this.timeUntilReSendOtp === 0;
  }

  private isDisable = false;
  private isEmptyAgreement = true;
  private step = 1;
  private timeUntilReSendOtp = 0;
  private otpTimer = "";
  private isReSendOtp = false;
  private imageCropper = false;
  private defaultPartnership: any = {
    is_temporary: true,
    company_id: null,
    email: "",
    phone: "",
    name: "",
    industry: null,
    country: null,
    province: null,
    city: null,
    address: "",
    logo: null,
    logo_preview: "",
    admin_name: "",
    admin_position: "",
    admin_email: "",
    admin_phone: "",
    message: "",
    agreement_doc: null,
    agreement_doc_preview: "",
    otp: "",
  };
  private partnership = {
    ...this.defaultPartnership,
  };
  private partnershipCheck = {
    ...this.defaultPartnership,
  };

  @Watch("partnership.logo")
  private onTrigger() {
    if (this.partnership.logo)
      this.partnership.logo_preview = URL.createObjectURL(
        this.partnership.logo
      );
    else this.partnership.logo_preview = null;
  }

  private debounceFind = _.debounce(() => {
    this.findByEmail();
  }, 500);

  private created() {
    this.partnershipCheckLatestAgreement({
      success: (response: AxiosResponse) => {
        this.isEmptyAgreement = !response.data.data.exists;
      },
    });
    this.getIndustry({
      success: (response: AxiosResponse) => {
        this.industries = response.data.data;
      },
    });
    this.getCountry({
      success: (response: AxiosResponse) => {
        this.countries = response.data.data;
      },
    });
  }

  private downloadLatestAgreement() {
    this.partnershipLatestAgreement({
      success: (response: AxiosResponse) => {
        if (response) {
          download(
            response.data.data.agreement_doc,
            `Agreement Document.${response.data.data.agreement_doc
              .split(".")
              .pop()}`
          );
        } else {
          toast.warning("There is no agreement file.");
        }
      },
    });
  }

  private findByEmail() {
    if (this.partnership?.email) {
      this.partnershipFind({
        params: {
          email: (this.partnership.email as string).toLowerCase(),
        },
        success: (response: AxiosResponse) => {
          let data = response.data.data;
          this.isDisable = data.is_found;
          if (data.is_found) {
            this.partnership.is_temporary = data.is_temporary;
            this.partnership.company_id = data.id;
            this.partnership.phone = data.phone
              .replaceAll("+62", "0")
              .replaceAll(" ", "");
            this.partnership.name = data.name;
            this.partnership.industry = this.industries.find(
              (value) => value.id === data.industry_id
            );
            this.partnership.country = this.countries.find(
              (value) => value.id === data?.city?.province.country_id
            );
            this.onCountryChange(this.partnership.country, () => {
              this.partnership.province = this.provinces.find(
                (value) => value.id === data?.city?.province?.id
              );
              this.onProvinceChange(this.partnership.province, () => {
                this.partnership.city = this.cities.find(
                  (value) => value.id === data?.city?.id
                );
              });
            });
            this.partnership.address = data.address;
            this.partnership.logo = true;
            this.partnership.logo_preview = data.logo;
            this.partnership.admin_name = data.personal.user.name;
            this.partnership.admin_position = data.personal.position;
            this.partnership.admin_email = data.personal.user.email;
            this.partnership.admin_phone = data.personal.phone;
            this.partnershipCheck = { ...this.partnership };
          } else {
            this.partnership = {
              ...this.defaultPartnership,
              email: this.partnership.email,
            };
            this.partnershipCheck = {
              ...this.defaultPartnership,
              email: this.partnership.email,
            };
          }
        },
      });
    } else {
      this.isDisable = true;
      this.partnership = { ...this.defaultPartnership };
    }
  }

  private onCountryChange(data: any, callback: any = null) {
    if (data) {
      this.getProvince({
        params: {
          country: data.id,
        },
        success: (response: AxiosResponse) => {
          this.provinces = response.data.data;
          if (callback) callback();
        },
      });
    } else {
      this.partnership.province = null;
      this.provinces = [];
    }
    this.partnership.city = null;
    this.cities = [];
  }

  private onProvinceChange(data: any, callback: any = null) {
    if (data) {
      this.getCity({
        params: {
          province: data.id,
        },
        success: (response: AxiosResponse) => {
          this.cities = response.data.data;
          if (callback) callback();
        },
      });
    } else {
      this.partnership.city = null;
      this.cities = [];
    }
  }

  private openFile(id: string) {
    document.getElementById(id)?.click();
  }

  private onAgreementChange(event: any) {
    const file = event.target.files[0];
    this.partnership.agreement_doc = file;
    this.partnership.agreement_doc_preview = file.name;
  }

  private onlyNumber(event: any) {
    let keyCode = event.keyCode ? event.keyCode : event.which;
    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
  }

  private isEmpty(data: any) {
    if (typeof data === "object") return !data;
    else if (Array.isArray(data)) return data.length === 0;
    else if (typeof data === "string") {
      if (!data.trim()) return true;
      else if (data === "undefined") return true;
      else if (data === "null") return true;
      return false;
    } else if (typeof data === "number") return data === 0;
    else if (typeof data === "undefined") return true;
    return false;
  }

  private isEmail(value: string) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      value
    );
  }

  private leadingZeros(num: number, totalLength: number = 2) {
    return String(num).padStart(totalLength, "0");
  }

  private otpCountdown() {
    if (!this.canReSendOtp) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      let m = this.leadingZeros(Math.floor(this.timeUntilReSendOtp / 60));
      let s = this.leadingZeros(this.timeUntilReSendOtp % 60);
      this.otpTimer = m + ":" + s;
      this.timeUntilReSendOtp -= 1;
      setTimeout(function () {
        self.otpCountdown();
      }, 1000);
      return;
    }
  }

  private sendOtp() {
    if (this.canReSendOtp) {
      if (!this.partnership.email) {
        toast.warning("The email field is required.");
        return false;
      }
      if (!this.isEmail(this.partnership.email)) {
        toast.warning("The email field is invalid.");
        return false;
      }
      this.partnershipSendOtp({
        params: {
          email: (this.partnership.email as string).toLowerCase(),
        },
        success: () => {
          this.isReSendOtp = true;
          this.timeUntilReSendOtp = 90;
          this.otpCountdown();
        },
      });
    }
  }

  private assign() {
    const formData = new FormData();
    for (const key in this.partnership) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      formData.append(key, this.partnership[key]);
    }
    formData.append("industry_id", (this.partnership.industry as any)?.id);
    formData.append("province_id", (this.partnership.province as any)?.id);
    formData.append("city_id", (this.partnership.city as any)?.id);
    if (!this.partnership.company_id) formData.delete("company_id");
    return formData;
  }
  private next(step: number) {
    this.partnership.phone = this.partnership.phone
      .replaceAll("+62", "0")
      .replaceAll(" ", "");
    if (step === 1) {
      this.step = 1;
    } else if (step === 2) {
      if (!this.partnership.email) {
        toast.warning("The email field is required.");
        return false;
      }
      if (!this.isEmail(this.partnership.email)) {
        toast.warning("The email field is invalid.");
        return false;
      }
      if (!this.partnership.phone) {
        toast.warning("The phone field is required.");
        return false;
      }
      if (
        (this.partnership.phone as string).replace("+62", "0").length < 9 ||
        (this.partnership.phone as string).replace("+62", "0").length > 13
      ) {
        toast.warning("The phone field is invalid.");
        return;
      }
      if (!this.partnership.name) {
        toast.warning("The name field is required.");
        return false;
      }
      if (!this.partnership.industry) {
        toast.warning("The industry field is required.");
        return false;
      }
      if (!this.partnership.province) {
        toast.warning("The province field is required.");
        return false;
      }
      if (!this.partnership.city) {
        toast.warning("The city field is required.");
        return false;
      }
      if (!this.partnership.address) {
        toast.warning("The address field is required.");
        return false;
      }
      if (!this.partnership.logo) {
        toast.warning("The logo field is required.");
        return false;
      }
      if (!this.partnership.admin_name) {
        toast.warning("The admin name field is required.");
        return false;
      }
      if (!this.partnership.admin_position) {
        toast.warning("The admin position field is required.");
        return false;
      }
      if (!this.partnership.admin_email) {
        toast.warning("The admin email field is required.");
        return false;
      }
      if (!this.isEmail(this.partnership.admin_email)) {
        toast.warning("The admin email field is invalid.");
        return false;
      }
      if (!this.partnership.admin_phone) {
        toast.warning("The admin phone field is required.");
        return false;
      }
      if (
        (this.partnership.admin_phone as string).replace("+62", "0").length <
          9 ||
        (this.partnership.admin_phone as string).replace("+62", "0").length > 13
      ) {
        toast.warning("The admin phone field is invalid.");
        return;
      }
      this.partnershipValidate({
        params: this.assign(),
        success: (res: AxiosResponse) => {
          if (res?.data) this.step = 2;
        },
      });
    } else if (step === 3) {
      if (!this.partnership.message) {
        toast.warning("The message field is required.");
        return false;
      }
      if (!this.partnership.agreement_doc) {
        toast.warning("The agreement field is required.");
        return false;
      }
      if (this.partnership.company_id) {
        this.partnershipRegister({
          params: this.assign(),
          success: (res: AxiosResponse) => {
            if (res) {
              toast.success("Partnership submitted.");
              this.step = 4;
            }
          },
        });
      } else {
        this.step = 3;
      }
    } else if (step === 4) {
      this.partnershipRegister({
        params: this.assign(),
        success: (res: AxiosResponse) => {
          if (res) {
            toast.success("Partnership submitted.");
            this.step = 4;
          }
        },
      });
    } else if (step === 5) {
      this.$router.push({
        name: "landing",
      });
    }
    const element = document.getElementById("download-agreement")?.offsetTop;
    window.scrollTo({ top: Number(element) });
  }
}
